import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    completePlanDeveloppementStepRequest,
    createDemandeFormationFromPlanRequest,
    fetchPlanDeveloppementStepRequest,
    generatePlanDeveloppementRecommendationsRequest,
} from "../../../../redux/actions/performanceActions";
import { asArray, StepState } from "../performanceUi";
import DemandeFormModal from "../../../Formation/ResponsableFormation/RessourcesJs/demandes/DemandeFormModal";
import { Eye } from "lucide-react";
import "./PlanDeveloppementStep.css";

const staticPlanCards = [
    {
        id: "leadership-management",
        titre: "Leadership et Management",
        nom: "Leadership et Management",
        category: "Management",
        description: "Développez vos pratiques de leadership, d'accompagnement et de pilotage d'équipe.",
        duration: "2 jour(s)",
        level: "Intermediaire",
        source: "PLAN_DEVELOPPEMENT",
        disabled: false,
        buttonLabel: "Demander",
        helper: "",
    },
    {
        id: "Gestiontemps",
        titre: "Gestion du temps",
        nom: "Gestion du temps",
        category: "Management",
        description: "Améliorez votre organisation, la gestion de vos priorites et votre efficacité au quotidien.",
        duration: "2 jour(s)",
        level: "Intermediaire",
        source: "PLAN_DEVELOPPEMENT",
        disabled: false,
        buttonLabel: "Demander",
        helper: "",
    },
    {
        id: "gestion-projet",
        titre: "Gestion de projet",
        nom: "Gestion de projet",
        category: "Organisation",
        description: "Structurez les priorités, les livrables et le suivi des actions avec une méthode claire.",
        duration: "3 jour(s)",
        level: "Tous niveaux",
        source: "PLAN_DEVELOPPEMENT",
        disabled: false,
        buttonLabel: "Demander",
        helper: "",
    },
    {
        id: "communication-efficace",
        titre: "Communication efficace",
        nom: "Communication efficace",
        category: "Soft skills",
        description: "Renforcez la qualité des échanges, la clarté des messages et la collaboration.",
        duration: "1 jour(s)",
        level: "Debutant",
        source: "PLAN_DEVELOPPEMENT",
        disabled: false,
        buttonLabel: "Demander",
        helper: "",
    },
];

const normalizeFormationForRequest = (formation) => ({
    id: formation.id,
    formationId: formation.formationId || formation.id,
    titre: formation.titre || formation.nom || formation.title,
    nom: formation.nom || formation.titre || formation.title,
    description: formation.description || "",
    categorie: formation.categorie || formation.category || formation.domaine || "",
    duree: formation.duree || formation.duration || "",
    source: formation.source || "PLAN_DEVELOPPEMENT",
});

const buildFormationCardFromItem = (item) => ({
    id: item.id,
    titre: item.formationNom || item.competenceNom || item.skillNom || "Formation",
    nom: item.formationNom || item.competenceNom || item.skillNom || "Formation",
    formation: {
        id: item.formationId,
        nom: item.formationNom || item.competenceNom || item.skillNom || "Formation",
    },
    category: item.formationReference || item.type || "Plan de developpement",
    description: item.recommendationReason || item.commentaire || "Action ajoutee au plan.",
    duration: null,
    level: item.gap != null ? `Gap ${item.gap}` : null,
    status: item.status || null,
    source: "PLAN_DEVELOPPEMENT",
    disabled: !!item.demandeId,
    buttonLabel: item.demandeId ? "Deja demandee" : "Demander",
    helper: item.demandeId
        ? "Une demande est deja associee a cet element."
        : null,
    itemId: item.id,
});

function PlanFormationCard({ card, onDemander, onVoirDetails }) {
    const title = card.nom || card.titre || card.formation?.nom || "Formation";
    const titleInitial = title.slice(0, 1).toUpperCase();

    return (
        <article className="plan-formation-card">
            <div className="plan-formation-card-media" onClick={() => onVoirDetails(card)} role="button" tabIndex={0} onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    onVoirDetails(card);
                }
            }}>
                <div className="plan-formation-card-placeholder">{titleInitial}</div>
                {/*<div className="plan-formation-card-overlay">*/}
                {/*    <span className="plan-formation-overlay-btn">Détails</span>*/}
                {/*</div>*/}
            </div>

            <div className="plan-formation-card-body">
                <div className="plan-formation-card-title" title={title}>{title}</div>
                <p className="plan-formation-card-desc">{card.description}</p>

                <div className="plan-formation-card-info">
                    <div className="plan-formation-info-row"><span>Domaine :</span> {card.category || "—"}</div>
                    <div className="plan-formation-info-row"><span>Durée :</span> {card.duration || "—"}</div>
                    <div className="plan-formation-info-row"><span>Niveau :</span> {card.level || "—"}</div>
                </div>

                {card.helper && <p className="plan-formation-card-helper">{card.helper}</p>}

                <div className="plan-formation-card-footer">
                    <button
                        type="button"
                        className="plan-formation-submit-btn"
                        disabled={card.disabled}
                        onClick={() => onDemander(card)}
                    >
                        {card.buttonLabel}
                    </button>
                    <div className="plan-formation-card-actions">

                        {/*<button*/}
                        {/*    type="button"*/}
                        {/*    className="plan-formation-action-btn"*/}
                        {/*    onClick={() => onVoirDetails(card)}*/}
                        {/*    title="Détails"*/}
                        {/*>*/}
                        {/*    <Eye size={18} />*/}
                        {/*</button>*/}

                    </div>
                </div>
            </div>
        </article>
    );
}

export default function PlanDeveloppementStep({ progressId }) {
    const dispatch = useDispatch();
    const slice = useSelector((state) => state.performance.planDeveloppement);
    const data = slice.stepByProgressId[String(progressId)];
    const loading = slice.loadingByProgressId[String(progressId)];
    const error = slice.errorByProgressId[String(progressId)];
    const recommendations = asArray(data?.recommendations);
    const items = asArray(data?.items);
    const hasFormationCampaign = data?.formationCampaignAssociated !== false;

    const [selectedPlanFormation, setSelectedPlanFormation] = useState(null);
    const [openDemandeModal, setOpenDemandeModal] = useState(false);
    const [detailsCard, setDetailsCard] = useState(null);

    useEffect(() => {
        if (progressId) {
            dispatch(fetchPlanDeveloppementStepRequest(progressId));
        }
    }, [dispatch, progressId]);

    const planFormationCards = useMemo(
        () => items.map(buildFormationCardFromItem),
        [items]
    );

    const handleOpenDemandeFormation = (card) => {
        const normalizedFormation = normalizeFormationForRequest({
            ...card,
            title: card.nom || card.titre,
            category: card.category,
            duration: card.duration,
        });
        setSelectedPlanFormation({
            ...card,
            formation: normalizedFormation,
        });
        setOpenDemandeModal(true);
    };

    const handleCloseDemandeFormation = () => {
        setOpenDemandeModal(false);
        setSelectedPlanFormation(null);
    };

    const handleSubmitDemandeFormation = (payloadFromModal) => {
        if (!selectedPlanFormation?.itemId) {
            handleCloseDemandeFormation();
            return;
        }

        dispatch(
            createDemandeFormationFromPlanRequest({
                planDeveloppementItemId: selectedPlanFormation.itemId,
                mode: payloadFromModal.mode,
                period: payloadFromModal.period,
                niveau: payloadFromModal.niveau,
                certifiante: payloadFromModal.certifiante,
                priorite: payloadFromModal.priorite,
                objectifs: payloadFromModal.objectifs,
                objectifs2: payloadFromModal.objectifs2,
                objectifs3: payloadFromModal.objectifs3,
                description: payloadFromModal.description,
            })
        );

        handleCloseDemandeFormation();
    };

    const cardsToDisplay = hasFormationCampaign ? planFormationCards : staticPlanCards;

    return (
        <StepState loading={loading} error={error} empty={!data}>
            <div className="plan-container">
                {/*<h2 className="plan-title">Mon plan de developpement</h2>*/}

                {!hasFormationCampaign ? (
                    <>
                        <h3 className="plan-section">Formations suggérées</h3>
                        <div className="plan-formation-grid">
                            {cardsToDisplay.map((card) => (
                                <PlanFormationCard
                                    key={card.id}
                                    card={card}
                                    onDemander={handleOpenDemandeFormation}
                                    onVoirDetails={setDetailsCard}
                                />
                            ))}
                        </div>
                    </>
                ) : (
                    <>
                        {data?.blockedReason && <div className="perf-state perf-state--warning">{data.blockedReason}</div>}
                        <div className="perf-actions perf-actions--top">
                            <button className="perf-btn" type="button" onClick={() => dispatch(generatePlanDeveloppementRecommendationsRequest(progressId))}>
                                Generer recommandations
                            </button>
                            <button className="perf-btn perf-btn--primary" type="button" onClick={() => dispatch(completePlanDeveloppementStepRequest(progressId))}>
                                Terminer l'etape
                            </button>
                        </div>

                        <h3 className="plan-section">Recommande pour vous</h3>
                        {recommendations.length === 0 && <div className="empty-state">Aucune recommandation.</div>}
                        <div className="plan-grid">
                            {recommendations.map((recommendation, index) => (
                                <div className="plan-card" key={recommendation.competenceNom || recommendation.skillNom || index}>
                                    <div className="plan-card__content">
                                        <h4>{recommendation.competenceNom || recommendation.skillNom || "Recommendation"}</h4>
                                        <span className="status IN_PROGRESS">Gap {recommendation.gap ?? "-"}</span>
                                        <p>{recommendation.reason || "Recommandation proposee par le backend."}</p>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <h3 className="plan-section">Formations de mon plan</h3>
                        {cardsToDisplay.length === 0 && <div className="empty-state">Aucun element selectionne</div>}
                        <div className="plan-formation-grid">
                            {cardsToDisplay.map((card) => (
                                <PlanFormationCard
                                    key={card.id}
                                    card={card}
                                    onDemander={handleOpenDemandeFormation}
                                    onVoirDetails={setDetailsCard}
                                />
                            ))}
                        </div>
                    </>
                )}
            </div>

            <DemandeFormModal
                open={openDemandeModal}
                onClose={handleCloseDemandeFormation}
                onSubmit={handleSubmitDemandeFormation}
                formation={selectedPlanFormation?.formation || null}
                campagneId={null}
                type="FORMATION"
            />

            {detailsCard && (
                <div className="plan-formation-details-overlay" onMouseDown={(event) => event.target === event.currentTarget && setDetailsCard(null)}>
                    <div className="plan-formation-details-panel">
                        <div className="plan-formation-details-header">
                            <div>
                                <h3>{detailsCard.formation?.nom || "Formation"}</h3>
                                <p>{detailsCard.category || "Plan de developpement"}</p>
                            </div>
                            <button type="button" className="plan-formation-details-close" onClick={() => setDetailsCard(null)}>
                                ×
                            </button>
                        </div>
                        <p className="plan-formation-details-text">{detailsCard.description}</p>
                    </div>
                </div>
            )}
        </StepState>
    );
}
